import { ObjectSchema, object, string, array } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { Device, Model } from '../../models/device';
yup.setLocale(locale);

export function deviceValidator(): ObjectSchema<Device> {
    return object({
        id: string().uuid().strict(),
        name: string().strict().required().max(30),
        models: array().ensure().nonNullable().strict(),
    })
        .strict()
        .noUnknown();
}

export function modelValidator(): ObjectSchema<Model> {
    return object({
        id: string().uuid().strict(),
        equipmentId: string().uuid().required().strict(),
        name: string().strict().required().max(30),
        code: string().strict().required().max(30),
        date: string().strict(),
        description: string().max(150).strict(),
    })
        .strict()
        .noUnknown();
}
